import api from "../../../components/axiosComp";
import axios from "axios";

const s3Client = axios.create();

// =======================
// S3 HELPERS FOR VENUE GROUNDS
// =======================

// PRESIGN for S3 direct upload (backend call – can use `api`)
export const presignUpload = async ({ folder, filename, contentType }) => {
  const { data } = await api.post("/api/uploads/presign", {
    folder,
    filename,
    contentType,
  });
  // returns: { uploadUrl, filePath }
  return data;
};


// DIRECT UPLOAD TO S3 (⚠️ must NOT use `api`)
export const uploadFileToS3 = async ({
  uploadUrl,
  file,
  contentType,
  onProgress,
}) => {
  const resp = await s3Client.put(uploadUrl, file, {
    headers: {
      "Content-Type": contentType || file.type || "application/octet-stream",
    },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) {
        onProgress(Math.round((evt.loaded / evt.total) * 100));
      }
    },
  });

  if (![200, 201, 204].includes(resp?.status)) {
    throw new Error(`S3 upload failed with status ${resp?.status || "unknown"}`);
  }

  return true;
};



// LIST grounds under a venue
export async function listVenueGrounds(venueId, params = {}) {
  const {
    page = 1,
    pageSize = 200,
    includeInactive = false, // 👈 add this
  } = params;

  const { data } = await api.get(`/api/superAdmin/venues/${venueId}/grounds`, {
    params: { page, pageSize, includeInactive }, // 👈 send it through
  });

  const items = Array.isArray(data?.items)
    ? data.items
    : Array.isArray(data)
      ? data
      : [];
  return items;
}

// (will be used in Parts 2–4)
export async function createVenueGround(venueId, payload) {
  const { data } = await api.post(
    `/api/superAdmin/venues/${venueId}/grounds`,
    payload,
  );
  return data;
}
export async function updateGround(id, payload) {
  const { data } = await api.put(`/api/superAdmin/grounds/${id}`, payload);
  return data;
}
export async function deleteGround(id) {
  const { data } = await api.delete(`/api/superAdmin/grounds/${id}`);
  return data;
}

// UPDATE a ground
export async function updateVenueGround(groundId, payload) {
  const { data } = await api.put(
    `/api/superAdmin/grounds/${groundId}`,
    payload,
  );
  return data;
}

// SOFT DELETE a ground
export async function deleteVenueGround(groundId) {
  const { data } = await api.delete(`/api/superAdmin/grounds/${groundId}`);
  return data;
}


export async function listSplitLayouts(venueId) {
  const { data } = await api.get(`/api/split-layouts`, {
    params: { venueId },
  });
  return data?.layouts || [];
}
